import { render } from "./AddTransfertModal.vue?vue&type=template&id=f9f1035c&ts=true"
import script from "./AddTransfertModal.vue?vue&type=script&lang=ts"
export * from "./AddTransfertModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__